import SliderHeaderComponent from '../components/SliderHeaderComponent'
import { connect } from 'react-redux'


const mapStateToProps = (state, ownProps) => ({    
        header:state.ui.title,
        index:state.ui.index+1,
        onPrevSlideClick:ownProps.onPrevSlideClick,
        onNextSlideClick:ownProps.onNextSlideClick,
        showNextButton:state.ui.nextSlideAvalaible ,
        showPrevButton:state.ui.previousSlideAvalaible
})
const VisibleSliderHeader = connect(mapStateToProps)(SliderHeaderComponent)

export default VisibleSliderHeader

